/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

let awsmobile = {}

if(window?.location?.href?.includes('https://www.docomobility.com/app/')){
    awsmobile = {
        "aws_project_region": "eu-central-1",
        "aws_cognito_region": "eu-central-1",
        "aws_user_pools_id": "eu-central-1_UbBT1ZV81",
        "aws_user_pools_web_client_id": "7313120ii4icgkbml2nu0ru9nn",
        "oauth": {
            "domain": "raas-mule.auth.eu-central-1.amazoncognito.com",
            "scope": [
                "aws.cognito.signin.user.admin",
                "email",
                "mule-api/api_delete",
                "mule-api/api_read",
                "mule-api/api_write",
                "openid",
                "phone",
                "profile"
            ],
            "redirectSignIn": "https://www.docomobility.com/app/",
            "redirectSignOut": "https://www.docomobility.com/app/",
            "responseType": "code"
        },
        "federationTarget": "COGNITO_USER_POOLS",
        "aws_cognito_username_attributes": [
            "EMAIL"
        ],
        "aws_cognito_social_providers": [
            "FACEBOOK",
            "GOOGLE"
        ],
        "aws_cognito_signup_attributes": [
            "EMAIL"
        ],
        "aws_cognito_mfa_configuration": "OPTIONAL",
        "aws_cognito_mfa_types": [
            "TOTP"
        ],
        "aws_cognito_password_protection_settings": {
            "passwordPolicyMinLength": 8,
            "passwordPolicyCharacters": [
                "REQUIRES_LOWERCASE",
                "REQUIRES_UPPERCASE",
                "REQUIRES_NUMBERS",
                "REQUIRES_SYMBOLS"
            ]
        },
        "aws_cognito_verification_mechanisms": [
            "EMAIL"
        ]
    };
}else if(window?.location?.href?.includes('https://www.pre.docomobility.com/app/')){
    awsmobile = {
        "aws_project_region": "eu-central-1",
        "aws_cognito_region": "eu-central-1",
        "aws_user_pools_id": "eu-central-1_sNoCBS24L",
        "aws_user_pools_web_client_id": "39nlcn56qb83md0ek914ppo5ne",
        "oauth": {
            "domain": "raas-mule-pre.auth.eu-central-1.amazoncognito.com",
            "scope": [
                "aws.cognito.signin.user.admin",
                "email",
                "mule-api/api_delete",
                "mule-api/api_read",
                "mule-api/api_write",
                "openid",
                "phone",
                "profile"
            ],
            "redirectSignIn": "https://www.pre.docomobility.com/app/",
            "redirectSignOut": "https://www.pre.docomobility.com/app/",
            "responseType": "code"
        },
        "federationTarget": "COGNITO_USER_POOLS",
        "aws_cognito_username_attributes": [
            "EMAIL"
        ],
        "aws_cognito_social_providers": [
            "FACEBOOK",
            "GOOGLE"
        ],
        "aws_cognito_signup_attributes": [
            "EMAIL"
        ],
        "aws_cognito_mfa_configuration": "OPTIONAL",
        "aws_cognito_mfa_types": [
            "TOTP"
        ],
        "aws_cognito_password_protection_settings": {
            "passwordPolicyMinLength": 8,
            "passwordPolicyCharacters": [
                "REQUIRES_LOWERCASE",
                "REQUIRES_UPPERCASE",
                "REQUIRES_NUMBERS",
                "REQUIRES_SYMBOLS"
            ]
        },
        "aws_cognito_verification_mechanisms": [
            "EMAIL"
        ]
    };
}else{
    awsmobile = {
        "aws_project_region": "eu-central-1",
        "aws_cognito_region": "eu-central-1",
        "aws_user_pools_id": "eu-central-1_LrnUr0I5q",
        "aws_user_pools_web_client_id": "2sf0btm94cpsfegkasn8915bkv",
        "oauth": {
            "domain": "raas-mule-int1.auth.eu-central-1.amazoncognito.com",
            "scope": [
                "aws.cognito.signin.user.admin",
                "email",
                "mule-api/api_delete",
                "mule-api/api_read",
                "mule-api/api_write",
                "openid",
                "phone",
                "profile"
            ],
            "redirectSignIn": "https://www.int.docomobility.com/app/",
            "redirectSignOut": "https://www.int.docomobility.com/app/",
            "responseType": "code"
        },
        "federationTarget": "COGNITO_USER_POOLS",
        "aws_cognito_username_attributes": [
            "EMAIL"
        ],
        "aws_cognito_social_providers": [
            "FACEBOOK",
            "GOOGLE"
        ],
        "aws_cognito_signup_attributes": [
            "EMAIL"
        ],
        "aws_cognito_mfa_configuration": "OPTIONAL",
        "aws_cognito_mfa_types": [
            "TOTP"
        ],
        "aws_cognito_password_protection_settings": {
            "passwordPolicyMinLength": 8,
            "passwordPolicyCharacters": [
                "REQUIRES_LOWERCASE",
                "REQUIRES_UPPERCASE",
                "REQUIRES_NUMBERS",
                "REQUIRES_SYMBOLS"
            ]
        },
        "aws_cognito_verification_mechanisms": [
            "EMAIL"
        ]
    };
}

export default awsmobile;
